import { ApiClientWrapper } from '@spike/api-client';
import { PaymentLink } from 'actions/payByLink/PayByLinkDto';
import { createSettingsWrapper, createWrapper, createWrapperForPayByLink } from 'api/ApiClient';
import { useContext } from 'react';
import { useStore } from 'react-redux';
import { BookingLocationContext } from './BookingLocationContext';
import useMasterData from './useMasterData';

export const useApiClientWrapper = (): ApiClientWrapper => {
    const store = useStore();
    const bookingLocation = useContext(BookingLocationContext);

    if (bookingLocation) {
        return bookingLocation.apiClientWrapper;
    }

    return createWrapper(store.getState());
};

export const useSettingsApiClientWrapper = (): ApiClientWrapper => {
    const store = useStore();
    return createSettingsWrapper(store.getState());
};

export const usePayByLinkApiClientWrapper = (paymentLink?: PaymentLink): ApiClientWrapper => {
    const store = useStore();
    const masterData = useMasterData();

    if (paymentLink === undefined) {
        return createWrapper(store.getState());
    }

    return createWrapperForPayByLink(paymentLink, masterData);
};

export default useApiClientWrapper;
